import styled from "styled-components";

export const Label = styled.h4`
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  letter-spacing: -0.02em;
  text-transform: capitalize;
`;

export const Subtitle = styled.p`
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  letter-spacing: -0.04em;
  color: rgba(138, 145, 156, 0.8);
  margin-top: 1em;
`;

export const Wrapper = styled.div`
  border: 1px solid rgba(138, 145, 156, 0.3);
  text-align: center;
  padding: 30px 15px;
  margin-top: 28px;
  margin-bottom: 28px;
  border-radius: 8px;
`;
